import GenAIRecentlyAddedUpdatedBarDiagram from '../../components/GenAIRecentlyAddedUpdatedHistogram/GenAIRecentlyAddedUpdatedBarDiagram';
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import GenAIRecentlyAddedUpdatedRangeSlider from '../../components/GenAIRecentlyAddedUpdatedHistogram/GenAIRecentlyAddedUpdatedRangeSlider'
import './GenAIFilterHistogramRecentlyAddedUpdated.css'
import { UtilityServices } from './../../utils/utilityServices'

export default function GenAIRecentlyAddedUpdatedFilterHistogram(props) {
  const {
    handleRecentlyAddedUpdated,
    gotoPage,
    years,
    yearSelection,
  } = props
  const [selectedIndex, setSelected] = useState(-1);
  const OPTIONS = ["Last Month", "Last 6 Months", "Last Year", "All"];
  useEffect(() => {
    if (yearSelection && yearSelection.min === 3 && yearSelection.max === 6) {
      setSelected(0)
    }
    else if (yearSelection && yearSelection.min === 2 && yearSelection.max === 6) {
      setSelected(1)
    }
    else if (yearSelection && yearSelection.min === 1 && yearSelection.max === 6) {
      setSelected(2)
    }
    else if (yearSelection && yearSelection.min === 0 && yearSelection.max === 6) {
      setSelected(3)
    }
    else {
      setSelected(-1)
    }
  }, [yearSelection])
  const onSelect = (index) => {
    setSelected(index)
    if (index == 0) {
      handleRecentlyAddedUpdated({ min: 3, max: 6 })
    }
    else if (index == 1) {
      handleRecentlyAddedUpdated({ min: 2, max: 6 })
    }
    else if (index == 2) {
      handleRecentlyAddedUpdated({ min: 1, max: 6 })
    }
    else {
      handleRecentlyAddedUpdated({ min: 0, max: 6 })
    }
  }
  if (years && years.length > 0) {
    const rangeMax = 6;
    let rangeMin = 0;

    if (rangeMax === rangeMin) {
      rangeMin -= 1
    }

    const sliderRange = years.map(x => x.key);
    const totalSelectedItems = () => {
      let totalItems = 0;
      for (let i = yearSelection.min; i < yearSelection.max; i++) {
        totalItems += years[i].doc_count;
      }
      return totalItems;
    }

    /**
      Determine the width of a bar. Used to create offsets for the rangeslider so the location of each selection dot
      is in the middle of the bar
    **/
    const barWidth = 100 / sliderRange.length
    const genAiBarWidth = 50 / sliderRange.length
    return (
      <>
        <div className="selected-range-card">
          <div className="selected-range-card__left">
            <span className="sr-label">Selected Range:</span>
            <span className="sr-value">{UtilityServices.getRecentlyAddedUpdatedSelectedYearDisplay(yearSelection)}</span>
          </div>

          <div className="selected-range-card__right">
            <span className="sr-label">Total Items:</span>
            <span className="sr-value sr-value--right">{totalSelectedItems().toLocaleString("en-us")}</span>
          </div>
        </div>
        <div className="gen-ai-recently-added-updated-bar-diagram">
          <GenAIRecentlyAddedUpdatedBarDiagram
            barWidth={barWidth}
            genAiBarWidth={genAiBarWidth}
            sliderRange={sliderRange}
            years={years}
            yearSelection={yearSelection}
          />
        </div>
        <div className="gen-ai-recently-added-updated-slider-content">
          <GenAIRecentlyAddedUpdatedRangeSlider
            handleRecentlyAddedUpdated={handleRecentlyAddedUpdated}
            offSet={barWidth / 2}
            rangeMax={rangeMax}
            rangeMin={rangeMin}
            gotoPage={gotoPage}
            years={years}
            yearSelection={yearSelection}
          />
        </div>
        <div className="quick-selection">
          <div className="quick-selection__meta">
            <span className="quick-selection__label">Quick Selection:</span>
            <span className="quick-selection__subtitle" />
            <span className="quick-selection__accent" />
          </div>

          <div className="quick-selection__options" role="list">
            {OPTIONS.map((opt, i) => {
              const isSelected = i === selectedIndex;
              return (
                <button
                  key={opt}
                  type="button"
                  role="listitem"
                  className={`quick-selection__option ${isSelected ? "is-selected" : ""}`}
                  aria-pressed={isSelected}
                  onClick={() => onSelect && onSelect(i)}
                >
                  <span className="quick-selection__text">{opt}</span>
                </button>
              );
            })}
          </div>
        </div>
      </>
    )
  }
  else {
    return null
  }
}
GenAIRecentlyAddedUpdatedFilterHistogram.propTypes = {
  handleYearSelection: PropTypes.func.isRequired,
  gotoPage: PropTypes.func.isRequired,
  years: PropTypes.arrayOf(
    PropTypes.object
  ).isRequired,
  yearSelection: PropTypes.object.isRequired
}
